var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24X24Success(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "48AE81B2-CEAC-425B-B7F0-D08FBF8979CF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "style-guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Style-Guide-v1.0",
    transform: "translate(-656.000000, -2092.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Calendar-Copy-22",
    transform: "translate(656.000000, 2092.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M16.2071068,9.29289322 C15.8466228,8.93240926 15.2793918,8.90467972 14.8871006,9.20970461 L14.7928932,9.29289322 L10.5,13.585 L8.70710678,11.7928932 L8.61289944,11.7097046 C8.22060824,11.4046797 7.65337718,11.4324093 7.29289322,11.7928932 C6.93240926,12.1533772 6.90467972,12.7206082 7.20970461,13.1128994 L7.29289322,13.2071068 L9.79289322,15.7071068 L9.88710056,15.7902954 C10.2467008,16.0699015 10.7532992,16.0699015 11.1128994,15.7902954 L11.2071068,15.7071068 L16.2071068,10.7071068 L16.2902954,10.6128994 C16.5953203,10.2206082 16.5675907,9.65337718 16.2071068,9.29289322 Z",
    id: "Shape",
    fillOpacity: 0.84,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24X24Success);
export default __webpack_public_path__ + "static/media/icon-24x24-success.05ed1982680b0d4c39c41339b3d46d61.svg";
export { ForwardRef as ReactComponent };